export enum responseCodes {
    OK = 1,
    Error = 2,
    Pending = 3,
    ReGenerate = 4,
    Reject = 5
}